import type { ForNodeType } from "@/components/features/_model/types";

type Props = {
	isSecret: ForNodeType<boolean>;
	onSetViewModel: (
		values: {
			key: "isPrivate";
			value: ForNodeType<boolean>;
		}[],
	) => void;
};

export const usePlanIsSecret = ({ isSecret, onSetViewModel }: Props) => {
	const onSetIsSecret = (value: boolean) => {
		onSetViewModel([
			{
				key: "isPrivate",
				value: {
					isEdited: true,
					value,
				},
			},
		]);
	};

	return {
		isSecret,
		onSetIsSecret,
	};
};
